import axios from 'axios';
import { useEffect, useState } from 'react';
import {app} from '../config'
import { getTokenfromUserObj } from '../utils/getTokenfromObj';
let url=`${app.URL}/org/fetchall`;
const useFetchTransactions = () => {
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const token=getTokenfromUserObj();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.post(`${app.URL}/trans/view`,{},{headers:{auth:token}});
        console.log(res);
        setResponse(res.data);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return { loading, response, error };
};

export default useFetchTransactions;
